export const INITIAL_COMPANIES_FILTERS = {
  search: '',
  url: '',
  wildcards: '',
  naces: [],
  industries: [],
  countries: [],
  revenue_min: '',
  revenue_max: '',
  employees_min: '',
  employees_max: '',
}
